import React, { useEffect } from "react";
import "./styles.css";
import { Link, useNavigate } from "react-router-dom";

export default function Influenciador() {
  const navigate = useNavigate();

  const handleGoBack = () => {
    navigate(-1);
  };

  useEffect(() => {
    setTimeout(() => {
      window.scrollTo(0, 0);
    }, 100);
  }, []);

  return (
    <div className="contrato-container">
      <div style={{ marginBottom: 30 }}>
        <Link onClick={handleGoBack}>Voltar para o Cadastro</Link>
      </div>
      <h1>CONTRATO DE DIVULGAÇÃO DE CONTEÚDO</h1>

      <section>
        <p>
          Este Termo de Responsabilidade estabelece as condições aplicáveis ao
          uso de parceria e colaboração ao Projeto Link do Bem. Ao acessar e
          clicar em aceitar a parceria, você concorda integralmente com os
          termos e condições descritos abaixo.
        </p>
      </section>

      <section>
        <h2>1. DO OBJETO</h2>
        <p>
          O objeto do contrato visa estabelecer os termos e condições da
          colaboração entre as partes envolvidas no projeto Link do Bem, para
          estabelecer a Campanha a ser desenvolvida, conforme especificado nas
          cláusulas abaixo.
        </p>
      </section>

      <section>
        <h2>2. DA CAMPANHA </h2>
        <p>
          2.1 O influenciador fará a divulgação das campanhas ativas do link do
          bem através de um link de afiliado.
        </p>
        <p>
          2.2 Os vídeos em formatos reels devem permanecer no feed durante a
          vigência da campanha. A remoção ou arquivamento antes, requer análise
          e aprovação prévia. Após o final da campanha, fica a critério do
          influenciador removê-lo ou não.
        </p>
      </section>

      <section>
        <h2>3. DA AGÊNCIA</h2>
        <p>
          3.1 A Agência se compromete a fornecer orientação e treinamento
          adequados para o Influenciador, ensinando-os como realizar as ações
          beneficentes propostas pelo projeto de forma eficaz e segura, bem como
          o suporte e orientações.
        </p>
        <p>
          3.2 A Agência é responsável por fornecer de forma transparente todos
          os detalhes sobre os ganhos e doações realizadas durante a campanha.
          Isso inclui entrar em contato com o ganhador, agendar a entrega do
          objeto doado e organizar todo o material necessário para a entrega
        </p>
      </section>

      <section>
        <h2>4. DO INFLUENCIADOR</h2>
        <p>
          4.1 O Influenciador deverá comprometer-se a participar ativamente das
          atividades propostas pelo projeto. Isso inclui divulgações nas
          plataformas escolhidas, conforme abaixo:
        </p>
        <ul>
          <li>A - Para Instagram – Formato stories e Reels</li>
          <li>B - Para Tiktok, Youtube Shorts e Kawai</li>
        </ul>
        <p>
          4.2 Os custos com criativos/vídeos e ações para divulgação da campanha
          serão custeados pelo Influenciador.
        </p>
      </section>

      <section>
        <h2>5. DAS POLÍTICAS E DIRETRIZES DO GOOGLE </h2>
        <p>
          5.1 O Influenciador deve seguir as diretrizes e procedimentos
          estabelecidos pela contratante para a realização das atividades do
          projeto, garantindo consistência e conformidade com os objetivos
          estabelecidos, bem como se obriga a ler e seguir todas as políticas do
          Google, para não incorrer em qualquer ação de bloqueio da plataforma.
        </p>
        <p>
          5.2 Em casos de violação das diretrizes da Plataforma Google, o
          Influenciador será advertido.
        </p>
      </section>

      <section>
        <h2>6. DO DIREITO AUTORAL E IMAGEM</h2>
        <p>
          O Influenciador cede de forma irretratável e irrevogável à Agência
          todos os direitos de imagem e autorais relacionados aos vídeos para e
          somente, referentes a entrega do prêmio da Campanha objeto deste
          contrato.
        </p>
      </section>

      <section>
        <h2>7. DO PAGAMENTO</h2>
        <p>
          7.1 Os pagamentos serão liberados no primeiro dia útil do mês, após 30
          dias do fechamento do mês anterior, após apuração. O pagamento será
          efetuado após o envio da Nota Fiscal, que deve ser emitida a partir do
          primeiro dia do mês. Notas emitidas antes da data deverão ser
          canceladas e notas enviadas após às 16:00 serão pagas no próximo dia
          útil.
        </p>
        <p>
          7.2 Após o desconto de 10% do valor bruto para o pagamento da
          plataforma Google, o Influenciador receberá a porcentagem de 50%
          (cinquenta por cento) do valor remanescente do valor gerado através do
          seu link de afiliado.
        </p>
        <p>
          7.3 Em caso de desativação da conta Adsense, ou seja, caso a
          Plataforma Google suspenda ou desative a conta comprovadamente, os
          valores retidos não serão repassados.
        </p>
      </section>

      <section>
        <h2>8. EMISSÃO DE NOTAS FISCAIS E PRAZOS DE PAGAMENTO</h2>
        <p>
          O pagamento será realizado após o influenciador emitir nota fiscal
          referente aos serviços prestados na campanha.
        </p>

         <p>
          Para manter a organização e o bom funcionamento do nosso fluxo financeiro, a partir de
          agora adotaremos um cronograma fixo de pagamentos, vinculado à emissão das notas
          fiscais
        </p>

        <b>8.1 Pagamentos serão realizados em duas etapas:</b>
        <ul>
          <li>
            Quem enviar a nota fiscal até às 16h do dia 01 (desde que seja dia útil), receberá no
            mesmo dia. Caso o dia 01 não seja útil, o pagamento será efetuado no próximo dia
            útil.
          </li>
          <br />
          <li>
            Quem enviar a nota fiscal entre os dias 02 e 10 do mês, receberá o pagamento no
            dia 11 (ou no próximo dia útil, caso o dia 11 não seja útil).
          </li>
        </ul>
        <b>8.2 Importante:</b>
        <br />
        <p>
          A nota fiscal referente ao valor acordado no mês vigente deve ser emitida até o dia 10 do
          mês. Caso isso não ocorra, será concedido um prazo de tolerância e a emissão deverá
          ocorrer entre o dia 01 e 10 do mês subsequente.
        </p>

        <p>
          Se a nota não for emitida até essa data, o valor correspondente será destinado a doações
          sociais, entendendo-se que a ausência da emissão dentro do prazo caracteriza renúncia ao
          recebimento.
        </p>

        <p>
          Nosso objetivo com essa medida é garantir mais previsibilidade, responsabilidade e
          agilidade no processo de repasse, além de evitar acúmulos e impactos no planejamento
          financeiro de ambas as partes.
        </p>

        <p>Agradecemos a compreensão e estamos à disposição para esclarecer quaisquer dúvidas.</p>
      </section>

    

      <section>
        <h2>9. DA RESCISÃO</h2>
        <p>
          Este contrato poderá ser rescindido a qualquer momento por acordo
          mútuo das partes, mediante comunicação por escrito com aviso prévio de
          7 dias.
        </p>
      </section>

      <section>
        <h2>10. DA VIGÊNCIA</h2>
        <p>
          O presente contrato não tem prazo determinado e poderá ser cancelado
          com antecedência de 15 dias por ambas as partes, mediante aviso prévio
          por e-mail. Eventuais alterações serão encaminhadas por e-mail e
          solicitado o aceite.
        </p>
      </section>

      <section>
        <h2>11. DA CONFIDENCIALIDADE E SIGILO</h2>
        <p>
          As partes se comprometem a manter em estrito sigilo todas as
          informações confidenciais, não divulgando, reproduzindo ou utilizando
          tais informações para qualquer fim que não esteja relacionado à
          execução deste contrato, exceto mediante consentimento prévio por
          escrito da parte proprietária das informações, sob pena de multa, a
          depender do prejuízo causado.
        </p>
      </section>

      <section>
        <h2>12. KNOW HOW</h2>
        <p>
          O Influenciador reconhece que o know-how fornecido pela Agência é
          confidencial e exclusivo, e concorda em utilizá-lo estritamente para
          os fins deste contrato.
        </p>
      </section>

      <section>
        <h2>13. DO FORO </h2>
        <p>
          13.1 Para dirimir quaisquer controvérsias decorrentes deste contrato,
          as partes elegem o foro da comarca de São Paulo, renunciando a
          qualquer outro, por mais privilegiado que seja.
        </p>

        <p>
          13.2 O influenciador declara ter lido, compreendido e concordado
          integralmente com todas as cláusulas e termos expostos neste contrato,
          aceitando-os de forma expressa.
        </p>
      </section>

      <span>Última atualização: 03/07/2025</span>

      <br />

      <Link to={"/cadastro"}>Voltar para o Cadastro</Link>
    </div>
  );
}
